import { useEffect, useCallback } from "react";
import { useNavigation } from "../context/NavigationContext";

// Simple hook to register navigation methods with parent wrapper
export const useNavigationRegistration = (goBackFn, handleNextPageFn) => {
  const { registerMethods } = useNavigation();

  const goBack = useCallback(goBackFn, [goBackFn]);
  const handleNextPage = useCallback(handleNextPageFn, [handleNextPageFn]);

  useEffect(() => {
    if (registerMethods) {
      registerMethods({ goBack, handleNextPage });
    }
  }, [goBack, handleNextPage, registerMethods]);

  return { goBack, handleNextPage };
};
